export const CATEGORIA_DISPLAY_MAP: Record<string, string> = {
  Sintomas: 'Síntomas',
  Diagnosticos: 'Diagnósticos',
  'Evento-Alarma': 'Evento de alarma',
  'Evento-Tracker': 'Evento de tracker',
  'Evento-Luminaria': 'Evento de luminaria',
  'Evento-Sirena': 'Evento de sirena',
  'Evento-Activo': 'Evento de activo',
  'Evento-Gateway': 'Evento de gateway',
  'Evento-Tecnico-Tracker': 'Servicio técnico de tracker',
  'Evento-Tecnico-Luminaria': 'Servicio técnico de luminaria',
  'Evento-Tecnico-Alarma': 'Servicio técnico de alarma',
  'Evento-Tecnico-Vehiculo': 'Servicio técnico de vehículo',
  'Evento-Tecnico-Sirena': 'Servicio técnico de sirena',
  'Evento-Tecnico-Gateway': 'Servicio técnico de gateway',
  'Evento-Tecnico-Activo': 'Servicio técnico de activo',
};

export function formatearCategoria(cat: string): string {
  return CATEGORIA_DISPLAY_MAP[cat] ?? cat;
}
